export const APP_SCREEN_HOME =
    "https://customer-assets.emergentagent.com/job_bookblend-hub/artifacts/n36xs569_fc05654a534381a22614626953f2cd81ab01f086d451dd8135735564f58e0153.jpeg";
export const APP_SCREEN_PROFILE =
    "https://customer-assets.emergentagent.com/job_bookblend-hub/artifacts/v6l3c4n8_76d80684892cdc78fe6f8df39fc3c021535a052b8d765a26130de22d7be1cce2.jpeg";
export const BOOKS_WALL_IMG =
    "https://customer-assets.emergentagent.com/job_bookblend-hub/artifacts/3gqf3rd8_e83da156e1f95e2765025d1f3e8161d229474a7892c32cb9d12152372fbf42d7.jpeg";
export const COZY_AUTUMN_IMG =
    "https://customer-assets.emergentagent.com/job_bookblend-hub/artifacts/t8j1d697_55623eca132e4db43473e51097cd19e8f13aae979bae2b79c270f732126e7d84.jpeg";
export const COZY_LIGHTS_IMG =
    "https://customer-assets.emergentagent.com/job_bookblend-hub/artifacts/b0lza97c_c873da395e6bac9a85ee189c40461b2687eddbb726fe4d1da35588d5bc4487ea.jpeg";
export const FOUNDER_IMG =
    "https://customer-assets.emergentagent.com/job_bookblend-hub/artifacts/pdr7h7xg_IMG_5645.jpeg";
